/**
 * 接口统一管理文件
 * Created by jian on 2021/07/16.
 */
export default {
  register: 'register',//登录,
  getTokenByUuid: 'getTokenByUuid',//根据uuid获取token
  saveAccept: 'saveAccept',//接受首页弹窗消息
  cancelAccept: 'cancelAccept',//取消接受弹窗
  planList: 'plan/list',//计划列表
  appliancesList: 'appliances/list',//获取电器列表
  appliancesCustomizeList: 'appliances/customizeList',//获取自定义电器列表
  appliancesAddCustomize: 'appliances/addCustomize',//获取自定义电器列表
  appliancesCustomizeDelete: 'appliances/customizeDelete',//删除自定义电器
  planAdd: 'plan/add',//创建计划
  planAddAppliances: 'plan/addAppliances',//添加电器
  appliancesDetail: 'appliances/detail',//电器详情
  appliancesCategoryList: 'appliances/categoryList',//电器类型列表
  planDeleteAppliances: 'plan/deleteAppliances',//删除计划电器
  planUpdateAppliances: 'plan/updateAppliances',//修改电器
  planCountEnergy: 'plan/countEnergy',//计算计划电器每日耗能
  planClearAll: 'plan/clearAll',//批量清除计划中所有电器
  planAppliancesDetail: 'plan/appliancesDetail',//计划中电器详情
  planAppliancesList: 'plan/appliancesList',//获取计划中所有电器
  planPlanPowerInfo: 'plan/planPowerInfo',//计算电器的功率信息
  planGetPlatformVoltage: 'plan/getPlatformVoltage',//可以选择电压
  planSavePlatformVoltage: 'plan/savePlatformVoltage',//保存电压
  planGetInverterType: 'plan/getInverterType',//获取逆变器类型
  planSaveInverterType: 'plan/saveInverterType',//保存逆变器类型
  planGetInverter: 'plan/getInverter',//获取逆变器的列表
  planSaveInverter: 'plan/saveInverter',//保存逆变器信息
  planGetBatteryType: 'plan/getBatteryType',//获取电池类型
  planSaveBatteryType: 'plan/saveBatteryType',//保存电池类型
  planGetBatteryVoltage: 'plan/getBatteryVoltage',//获取电池电压
  planSaveBatteryVoltage: 'plan/saveBatteryVoltage',//保存电池电压
  planGetBattery: 'plan/getBattery',//获取电池列表
  planSaveBattery: 'plan/saveBattery',//保存选中电池
  planGetChargeControllerType: 'plan/getChargeControllerType',//获取充电器类型
  planSaveChargeControllerType: 'plan/saveChargeControllerType',//保存充电器类型
  planGetAutomaticCalculationSunHours: 'plan/getAutomaticCalculationSunHours',//获取平均日照时间
  planSaveAutomaticCalculation: 'plan/saveAutomaticCalculation',//保存峰值日照时间
  planGetSolarPanelType: 'plan/getSolarPanelType',//获取太阳能组件类型
  planSaveSolarPanelType: 'plan/saveSolarPanelType',//保存太阳能组件类型
  planSaveAreaOfRoof: 'plan/saveAreaOfRoof',//保存车顶面积
  planGetSolarPanel: 'plan/getSolarPanel',//获取太阳能板列表
  planSaveSolarPanel: 'plan/saveSolarPanel',//保存太阳能板
  planGetChargeController: 'plan/getChargeController',//获取充电控制器列表
  planSaveChargeController: 'plan/saveChargeController',//保存充电控制器
  planGetACDCCharge: 'plan/getACDCCharge',//获取ac-dc充电器列表
  planSaveACDCCharge: 'plan/saveACDCCharge',//保存ac-dc充电器
  planGetBatteryOutputVoltage: 'plan/getBatteryOutputVoltage',//获取电池输出电压
  planSaveBatteryOutputVoltage: 'plan/saveBatteryOutputVoltage',//保存电池输出电压
  planGetDCDCCharge: 'plan/getDCDCCharge',//获取dc-dc充电器
  planSaveDCDCCharge: 'plan/saveDCDCCharge',//保存dc-dc充电器
  planGetSolution: 'plan/getSolution',//获取线材和配件信息
  planAddCart: 'plan/addCart',//添加计划到购物车
  planGetPlanInfo: 'plan/getPlanInfo',//获取计划车辆电器信息
  planNewSaveAreaOfRoof: 'plan/newSaveAreaOfRoof',//新保存车顶面积
  planGetCurvedAreaSolerPanel: 'plan/getCurvedAreaSolerPanel',//柔性组件
  planSaveCurvedAreaSolerPanel: 'plan/saveCurvedAreaSolerPanel',//保存柔性太阳能板
  planGetFlatAreaSolerPanel: 'plan/getFlatAreaSolerPanel',//获取刚性太阳能板
  planSaveFlatAreaSolerPanel: 'plan/saveFlatAreaSolerPanel',//保存刚性太阳能板
  planGetConnectionOfPanele: 'plan/getConnectionOfPanele',//获取连接串联并联数量
  planSaveConnectionOfPanele: 'plan/saveConnectionOfPanele',//保存太阳能串联并联数量
  planGetChargeControllerTypeNew: 'plan/getChargeControllerTypeNew',//新获取控制器类型
  planSaveChargeControllerTypeNew: 'plan/saveChargeControllerTypeNew',//新保存充电控制器类型
  planGetChargeControllerNew: 'plan/getChargeControllerNew',//新获取控制器类型列表
  planSaveNoChargeController: 'plan/saveNoChargeController',//无需控制器获取状态
  planSaveChargeControllerNew: 'plan/saveChargeControllerNew',//新保存充电控制器
  planGetChargeControllerNext: 'plan/getChargeControllerNext',//获取控制器下一步跳转
  planGetSolarEnergyGeneration: 'plan/getSolarEnergyGeneration',//获取太阳能板充电信息
  planGetWiring: 'plan/getWiring',//获取接线图信息
  planGetSolutionNew: 'plan/getSolutionNew',//获取接线图组件
  planSavePlan: 'plan/savePlan',//新保存计划接口
  planSavePlanReplace: 'plan/savePlanReplace',//保存新计划替换旧计划
  planDeletePlan: 'plan/deletePlan',//删除计划
  getLoginInfo: 'getLoginInfo',//获取登录信息
  planAddCartNew: 'plan/addCartNew',//新添加购物车
  bindUserId: 'bindUserId',//绑定用户id
  likesCount: 'likesCount',//获取游戏点赞数量
  likes: 'likes',//给游戏点赞
  planSaveCartInfo: 'plan/saveCartInfo',//保存购物车数据
  storefrontCart: 'storefront/cart',//获取购物车id
  planGetCartId: 'plan/getCartId',//中转获取cartID

}



// WEBPACK FOOTER //
// ./src/js/interface/index.js